(function () {
  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function setStatus(statusNode, type, message) {
    if (!statusNode) return;
    statusNode.classList.remove('is-error', 'is-ok');
    statusNode.classList.add(type === 'ok' ? 'is-ok' : 'is-error');
    statusNode.textContent = message;
  }

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  onReady(function () {
    var forms = document.querySelectorAll('[data-dbc-mail-form]');

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var statusNode = form.querySelector('[data-form-status]');
        var data = new FormData(form);
        var name = String(data.get('name') || '').trim();
        var email = String(data.get('email') || '').trim();
        var phone = String(data.get('phone') || '').trim();
        var reason = String(data.get('reason') || '').trim();
        var message = String(data.get('message') || '').trim();
        var target = form.getAttribute('data-email') || (window.dbcContact && window.dbcContact.email) || 'shawnsims@me.com';

        if (!name) {
          setStatus(statusNode, 'error', 'Name is required.');
          return;
        }

        if (!email || !isEmail(email)) {
          setStatus(statusNode, 'error', 'Enter a valid email address.');
          return;
        }

        if (!reason) {
          setStatus(statusNode, 'error', 'Please choose a reason for contact.');
          return;
        }

        if (!message) {
          setStatus(statusNode, 'error', 'Message is required.');
          return;
        }

        var subject = '[Dream Big Fund] ' + reason + ' - ' + name;
        var body = 'Name: ' + name + '\nEmail: ' + email + '\nPhone: ' + (phone || '-') + '\nReason: ' + reason + '\n\n' + message;
        var mailto = 'mailto:' + target + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);

        setStatus(statusNode, 'ok', 'Opening your email app to finish sending...');
        window.location.href = mailto;
        form.reset();
      });
    });
  });
}());
